import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ContractInfoNewEditForm from './ContractInfoNewEditForm';
// ----------------------------------------------------------------------

export default function ContractInfoCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit
          ? `${translate('contractsInfo.CreateTitle')}`
          : `${translate('contractsInfo.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('contractsInfo.CreateTitle')}`
              : `${translate('contractsInfo.UpdateTitle')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('contractsInfo.ContractInfoList')}`,
              href: PATH_DASHBOARD.ContractInfo.list,
            },
            {
              name: !isEdit
                ? `${translate('ContractInfo.CreateTitle')}`
                : `${translate('ContractInfo.UpdateTitle')}`,
            },
          ]}
        />
        <ContractInfoNewEditForm />
      </Container>
    </Page>
  );
}
